import type {Component} from "vue";
import {defineAsyncComponent} from "vue";

/**
 * The components a program may substitute for the generic Backing body.
 *
 * A program whose course does not live in the backing engine — the BPM, whose
 * state is served by the HDS — renders its own card here. The registry is what
 * keeps the generic module agnostic: `BackingDetails` looks a slug up, it never
 * names a program.
 *
 * Loaded asynchronously so that a program's module, and the client it calls,
 * only reach the bundle of the pharmacies that open its card.
 */
const extensions: Record<string, Component> = {
    bpm: defineAsyncComponent(
        () => import("@/medication-checkup/components/MedicationCheckupBacking.vue")
    )
};

/**
 * Read the component a program substitutes for the generic body, if any.
 *
 * A backing with no slug, or a slug no program claims, has no extension: the
 * caller falls back to the generic rendering.
 */
export const backingExtension = (slug: string | null): Component | null => {
    if (slug === null) {
        return null;
    }

    return extensions[slug] ?? null;
};
